import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { Button } from "@blueprintjs/core";
import { ImagesGrid } from "polotno/side-panel";
import { getImageSize } from "polotno/utils/image";
import { doRequest } from "../../../utils/helper";
import { useDropzone } from "react-dropzone";
import { useDispatch } from "react-redux";
import { showToast } from "../../../redux/slices/ToastSlice";
import { BeatLoader } from "react-spinners";

export const UploadPanel = observer(({ store }) => {
    //  const [images, setImages] = React.useState([]);
    const [imageList, setImageList] = React.useState([]);
    const [imageListLoading, setImageListLoading] = React.useState(false);
    const [isUploading, setUploading] = React.useState(false);
    //  const [uploadingFiles, setUploadingFiles] = React.useState([]);
    const limit = 10;
    const [page, setPage] = useState(1);
    // const [totalItems, setTotalItems] = useState(0);
    const [loadmore, setLoadmore] = useState(false);
    const dispatch = useDispatch();

    const fetchMoreImages = async () => {
        setPage((prev) => +prev + 1);
        if (loadmore) {
            getImagesFromApi(+page + 1);
        }
    };
    const getImagesFromApi = async (p) => {
        setImageListLoading(true);
        // setImageList(() => []);
        let data = {
            page: p ? p : page,
            limit: limit,
        };
        const response = await doRequest(
            null,
            "GET",
            `file/user-files-list?page=${data?.page}&limit=${data.limit}`
        );
        // setTotalItems(response?.data?.totalItems);
        if (response?.data?.images.length < limit) {
            setLoadmore(false);
        } else {
            setLoadmore(true);
        }
        const dataMap = response?.data?.images?.map((item) => {
            return {
                id: item?.id + "_" + Date.now(),
                // id: item?.id,
                // url: item?.file_url,
                url: item.thumbnail_url || item.file_url,
                previewUrl: item.thumbnail_url || item.file_url,
                originalUrl: item.file_url,   
                size:item?.file_size_mb
            };
        });
        if (loadmore) {
            setImageList((prev) => [...prev, ...dataMap]);
            /*  const filteredImageList = dataMap.filter(
                (item) => !imageList.some((image) => image.id === item.id)
            );
            setImageList(filteredImageList); */
        } else {
            setImageList(() => [...dataMap]);
        }
        setImageListLoading(false);
    };

    const saveImage = async (files) => {
        try {
            // delay to emulate network request
            // await delay();

            // Create skeleton entries for each file being uploaded
            /*  const skeletonFiles = files.map((file, index) => ({
                id: `uploading_${Date.now()}_${index}`,
                fileName: file.name,
                isUploading: true,
                file: file,
            })); */

            //  setUploadingFiles(skeletonFiles);

            const uploadedFiles = [];

            for (const file of files) {
                const fileName = file.name;
                const fileSize = file.size;

                try {
                    // Step 1: Get presigned URL
                    const presignedUrlPayload = {
                        fileName: fileName,
                        folderName: "images",
                    };

                    const presignedResponse = await doRequest(
                        presignedUrlPayload,
                        "POST",
                        "file/user-present-url"
                    );

                    if (
                        !presignedResponse?.uploadUrl ||
                        !presignedResponse?.fileUrl
                    ) {
                        throw new Error("Unable to get presigned URL");
                    }

                    const { uploadUrl, fileUrl } = presignedResponse;

                    // Step 2: Upload file to S3 using presigned URL
                    const uploadSuccess = await new Promise(
                        (resolve, reject) => {
                            const xhr = new XMLHttpRequest();

                            xhr.open("PUT", uploadUrl, true);
                            xhr.setRequestHeader("Content-Type", file.type);

                            xhr.onload = function () {
                                if (xhr.status >= 200 && xhr.status < 300) {
                                    resolve(true);
                                } else {
                                    reject(
                                        new Error(
                                            `Upload failed with status: ${xhr.status}`
                                        )
                                    );
                                }
                            };

                            xhr.onerror = function () {
                                reject(
                                    new Error("Network error during upload")
                                );
                            };

                            xhr.upload.onprogress = function (e) {
                                if (e.lengthComputable) {
                                    const percentComplete =
                                        (e.loaded / e.total) * 100;
                                    console.log(
                                        `Upload progress: ${percentComplete.toFixed(
                                            2
                                        )}%`
                                    );
                                }
                            };

                            xhr.send(file);
                        }
                    );

                    if (!uploadSuccess) {
                        throw new Error("Failed to upload to S3");
                    }

                    // Add file info to array for final API call
                    uploadedFiles.push({
                        fileName: fileName,
                        fileUrl: fileUrl,
                        fileSize: fileSize,
                    });
                } catch (error) {
                    console.error(
                        "error in saveImage for file:",
                        fileName,
                        error
                    );
                    dispatch(
                        showToast({
                            message: `Unable to upload file: ${fileName}, ${error.message}`,
                            type: "error",
                        })
                    );
                }
            }

            // Step 3: Store uploaded files metadata (only if we have successfully uploaded files)
            if (uploadedFiles.length > 0) {
                try {
                    const storeFilesPayload = {
                        files: uploadedFiles,
                    };

                    const storeResponse = await doRequest(
                        storeFilesPayload,
                        "POST",
                        "file/store-uploaded-user-files"
                    );
                    if (storeResponse?.message === "Files saved successfully") {
                        const newImageList = storeResponse.files.map(
                            (item) => ({
                                id: item?.id + "_" + Date.now(),
                                // url: item?.file_url,
                                url: item.thumbnail_url || item.file_url,
                                previewUrl: item.thumbnail_url || item.file_url,
                                originalUrl: item.file_url,
                                name: item?.file_name,
                                size: parseFloat(item.file_size / (1024 * 1024)).toFixed(2) + " MB"
                            })
                        );
                        setImageList((prev) => [...newImageList, ...prev]);
                        dispatch(
                            showToast({
                                message: "Images uploaded successfully",
                                type: "success",
                            })
                        );
                    } else {
                        throw new Error("Failed to store file metadata");
                    }
                } catch (error) {
                    console.error("error storing file metadata:", error);
                    dispatch(
                        showToast({
                            message: `Files uploaded but metadata storage failed: ${error.message}`,
                            type: "error",
                        })
                    );
                }
            }
        } catch (error) {
            console.error("error in saveImage", error);
            dispatch(
                showToast({
                    message: `Something went wrong. ${error.message}`,
                    type: "error",
                })
            );
        } finally {
            setUploading(false);
            //  setUploadingFiles([]); // Clear uploading files
        }
    };
    const deleteImage = async (id) => {
        const images = JSON.parse(localStorage.getItem("images") || "[]");
        const newImages = images.filter((image) => image.id !== id);
        localStorage.setItem("images", JSON.stringify(newImages));
        const response = await doRequest(
            "",
            "GET",
            `file/delete-user-image?id=${id}`
        );
        if (response?.message === "Image deleted successfully") {
            const filteredImageList = imageList.filter(
                (image) => image.id !== id
            );

            setImageList(filteredImageList);

            dispatch(
                showToast({
                    message: "Image deleted successfully",
                    type: "success",
                })
            );
        } else {
            alert("Failed to delete image");
            throw new Error("Failed to delete image");
        }
    };


    useEffect(() => {
        localStorage.removeItem("images");
    }, []);

    const { getRootProps, getInputProps } = useDropzone({
        accept: {
            "image/*": [
                ".png",
                ".jpeg",
                ".jpg",
                ".bmp",
                ".svg",
                ".webp",
                ".tif",
                ".heic",
                ".heif",
            ],
        },

        onDrop: (acceptedFiles, rejectedFiles) => {
            if (rejectedFiles?.length > 0) {
                alert("can not select video ");
            } else handleFileInput(acceptedFiles);
        },
    });

    const handleFileInput = async (files) => {
        // each file of more than 10 mb is not allowed
        const isAllowed = files.every((file) => file.size <= 10 * 1024 * 1024);
        if (!isAllowed) {
            console.error("File size should be less than 10 MB");
            dispatch(
                showToast({
                    message: "File size should be less than 10 MB",
                    type: "error",
                })
            );
            return;
        }

        // const { target } = e;
        setUploading(true);
        if (files) {
            await saveImage(files);
        }
        // await load();
        setUploading(false);
        // target.value = null;
    };

    React.useEffect(() => {
        // load();
        getImagesFromApi();
    }, []);


    return (
        <div
            style={{ height: "100%", display: "flex", flexDirection: "column" }}
        >
            <div style={{ marginBottom: isUploading ? "0px" : "20px" }}>
                <div
                    {...getRootProps({
                        className: "dropzone-upload-wrapper",
                    })}
                >
                    <input {...getInputProps()} />
                    <div className="dropzone-inner-wrapper">
                        {/* <small className="py-2 text-black-50">or</small> */}
                        <div>
                            <Button
                                className="text_up_14 px-4 bdr0"
                                disabled={isUploading}
                                style={{ marginBottom: "0px" }}
                            >
                                <span className="px-2">
                                    {isUploading
                                        ? "Uploading..."
                                        : "Upload Image"}
                                </span>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>

            {isUploading && (
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "20px",
                        gap: "10px",
                    }}
                >
                    <BeatLoader color="#2A1FB3" size={10} />
                </div>
            )}

            <ImagesGrid
                images={imageList}
                loadMore={loadmore ? fetchMoreImages : false}
                // getPreview={(image) => image.url}
                getPreview={(image) => image.previewUrl}
                isLoading={imageListLoading}
                crossOrigin="anonymous"
                getCredit={(image) => (
                    <div>
                        <Button
                            icon="trash"
                            onClick={async (e) => {
                                e.stopPropagation();
                                if (
                                    window.confirm(
                                        "Are you sure you want to delete the image?"
                                    )
                                ) {
                                    await deleteImage(
                                        image.id,
                                        dispatch,
                                        getImagesFromApi
                                    );
                                    // await load();
                                }
                            }}
                        ></Button>
                        <span> {image.size || "Size unknown"}</span>
                    </div>
                )}
                onSelect={async (image, pos, element) => {
                    const url = image.originalUrl;
                    let { width, height } = await getImageSize(url);
                    const isSVG =
                        url.indexOf("svg+xml") >= 0 || url.indexOf(".svg") >= 0;

                    const type = isSVG ? "svg" : "image";

                    if (
                        element &&
                        element.type === "svg" &&
                        !element.locked &&
                        type === "image"
                    ) {
                        element.set({ maskSrc: url });
                        return;
                    }

                    if (
                        element &&
                        element.type === "image" &&
                        !element.locked &&
                        type === "image"
                    ) {
                        element.set({ src: url });
                        return;
                    }

                    // Position image at top-left corner
                    const x = 0;
                    const y = 0;

                    store.activePage?.addElement({
                        type,
                        src: url,
                        x,
                        y,
                        width,
                        height,
                    });
                }}
            />

            {/* {isUploading ? (
        <SkeletonGrid />
      ) : (
       
      )} */}
        </div>
    );
});
